import { useEffect } from "react"
import Bowser from "bowser"
import { AppState } from "../types"
import { UIAction } from "../update/ui"

const browser = Bowser.getParser(
  typeof window !== "undefined" ? window.navigator.userAgent : "NoBrowser"
)

interface BrowserDetectProps {
  appState: AppState
  uiDispatch: React.Dispatch<UIAction>
}

const browserBlackList = {
  // Browser Blacklist
  // Aliases: https://github.com/lancedikson/bowser/blob/master/src/constants.js
  edge: "<18",
  ie: "<12",
}

export default function useBrowserDetect({
  uiDispatch,
  appState,
}: BrowserDetectProps): string {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (appState === AppState.DETECTING_BROWSER) {
        // BROWSER DETECTION
        const currentBrowser = browser.getBrowser()
        console.log("Current Browser", currentBrowser)
        if (browser.satisfies(browserBlackList)) {
          console.error("Browser is unsupported")
          uiDispatch({
            type: "UpdateAppState",
            payload: AppState.UNSUPPORTED_BROWSER,
          })
        } else {
          console.log("Browser is supported")
          uiDispatch({
            type: "UpdateAppState",
            payload: AppState.LOADING,
          })
        }
      }
    } else {
      uiDispatch({
        type: "UpdateAppState",
        payload: AppState.LOADING,
      })
    }
  }, [appState, uiDispatch])

  return "Browser Detection"
}
